import { CardClient } from '@atlaskit/link-provider';

import { getEnv } from '../config';

const ENV_MAP: Record<Env, 'dev' | 'staging' | 'production' | undefined> = {
  test: undefined,
  local: 'staging',
  ddev: 'staging',
  'stg-east': undefined,
  'stg-apse': undefined,
  'stg-fedm-east': undefined,
  // we don't want to provide an environment for prod as it will provide an absolute url rather than a relative gateway url
  'prod-east': undefined,
  'prod-fedm-east': undefined,
};

const envKey = ENV_MAP[getEnv()];

export const cardClient = new CardClient(envKey);

export const useCardClient = () => {
  return cardClient;
};

export const AUTH_FLOW = 'oauth2';
